import { Hero } from "@/components/Hero";
import { Problem } from "@/components/Problem";
import { TargetAudience } from "@/components/TargetAudience";
import { Solution } from "@/components/Solution";
import { HowItWorks } from "@/components/HowItWorks";
import { SmartNotes } from "@/components/SmartNotes";
import { Features } from "@/components/Features";
import { Privacy } from "@/components/Privacy";
import { TrustBadges } from "@/components/TrustBadges";
import { StatsCounter } from "@/components/StatsCounter";
import { CTA } from "@/components/CTA";
import { Footer } from "@/components/Footer";
import { Navbar } from "@/components/Navbar";
import { ScrollProgress } from "@/components/ScrollProgress";
import { BackToTop } from "@/components/BackToTop";
import { SEO } from "@/components/seo/SEO";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Index = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/settings", { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-background" id="main-content">
      <SEO
        title="Outlook Add-in: Email Signatures to Contacts | Email2Contact"
        description="Email2Contact extracts email signatures in Outlook and saves complete contacts in one click. GDPR-compliant, EU-hosted AI, zero data retention."
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "Email2Contact",
          url: "https://email2contact.com",
          publisher: {
            "@type": "Organization",
            name: "Celsios GmbH",
            url: "https://email2contact.com",
          },
          inLanguage: "en",
        }}
      />
      <ScrollProgress />
      <Navbar transparentOnTop />
      <Hero />
      <TrustBadges />
      <Problem />
      <TargetAudience />
      <Solution />
        <HowItWorks />
        <SmartNotes />
        <Features />
      <Privacy />
      <StatsCounter />
      <CTA />
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Index;
